import { organisationSuggester } from "../droom/suggesters"

class OrgPicker {
  constructor(el) {
    this._container = el;
    this._input = el.querySelector('input[type="text"]');
    this._output = el.querySelector('input[type="hidden"]');
    this._suggester = organisationSuggester(this._input, {
      onSelect: this.attachToOrganisation.bind(this)
    });
    this._detacher = el.querySelector('.detach');
    this._detacher.addEventListener("click", this.detachFromOrganisation.bind(this));
    this.showAttachementState();
  }

  // TODO: use suggestion.years to warn if this organisation is already in this procession.
  attachToOrganisation(value, id, suggestion) {
    this._output.value = id;
    if (suggestion.serial) {
      document.querySelectorAll('[data-suggest="serial_name"]').forEach((el) => el.value = suggestion.serial.name || "");
      if (suggestion.serial.pic) {
        document.querySelectorAll('[data-suggest="pic_title"]').forEach((el) => el.value = suggestion.serial.pic.title || "");
        document.querySelectorAll('[data-suggest="pic_forename"]').forEach((el) => el.value = suggestion.serial.pic.forename || "");
        document.querySelectorAll('[data-suggest="pic_surname"]').forEach((el) => el.value = suggestion.serial.pic.surname || "");
        document.querySelectorAll('[data-suggest="pic_job"]').forEach((el) => el.value = suggestion.serial.pic.job || "");
        document.querySelectorAll('[data-suggest="pic_email"]').forEach((el) => el.value = suggestion.serial.pic.email || "");
        document.querySelectorAll('[data-suggest="pic_phone"]').forEach((el) => el.value = suggestion.serial.pic.phone || "");
        document.querySelectorAll('[data-suggest="pic_address"]').forEach((el) => el.value = suggestion.serial.pic.address || "");
      }
      if (suggestion.serial.serial_type_ids) {
        document.querySelectorAll('[data-suggest="serial_types"]').forEach((el) => {
          el.checked = suggestion.serial.serial_type_ids.includes(parseInt(el.value));
        });
      }
      document.querySelectorAll('[data-suggest="serial_invitable"]').forEach((el) => {
        el.checked = !!suggestion.serial.invitable;
      });
    }
    this.showAttachementState();
  }

  detachFromOrganisation(e) {
    this._output.value = "";
    this.showAttachementState();
  }

  showAttachementState() {
    if (this._output.value) {
      this._container.classList.add('attached');
      this._container.classList.remove('detached');
    } else {
      this._container.classList.add('detached');
      this._container.classList.remove('attached');
    }
  }

}

function orgPicker(el) {
  return new OrgPicker(el);
}

export default orgPicker;